/**
 * Generated by orval v6.19.1 🍺
 * Do not edit manually.
 * BBO Accounting Location Api
 * Accounting Location API defining how to get and modify Accounting Locations

REST APIs for Back Office stock count service. This service is specifically designed for stock functionality- stock count. Feature services are.<ul><li>Get Stock Count Type List</li></ul>

REST APIs for Back Office Forex Management Service. This service is specifically designed for forex functionality- forex counting, variance declaration, forex details, and etc. Feature services are.<ul><li>Branch Forex Overview</li><li>Fetch the Forex currencies</li></ul>

Provide Task Status and Uncompleted Task History
 * OpenAPI spec version: 0.1.0
 */
import { useMutation } from '@tanstack/react-query';
import type { MutationFunction, UseMutationOptions } from '@tanstack/react-query';

import type {
  BboDeclarationBadRequestResponse,
  BboDeclarationFailureResponseResponse,
  DiscrepancyPayload,
  ForbiddenResponse,
  SuccessResponse,
  UnauthorizedResponse,
} from '../model';
import { customInstance } from '../mutator/customInstance';
import type { ErrorType } from '../mutator/customInstance';

/**
 * @summary Update Discrepancy
 */
export const updateDiscrepancy = (
  discrepancyID: string,
  discrepancyPayload: DiscrepancyPayload,
) => {
  return customInstance<SuccessResponse>({
    url: `/bm-declaration-service/v1/discrepancy/${discrepancyID}`,
    method: 'put',
    headers: { 'Content-Type': 'application/json' },
    data: discrepancyPayload,
  });
};

export const getUpdateDiscrepancyMutationOptions = <
  TError = ErrorType<
    | BboDeclarationBadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | BboDeclarationFailureResponseResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateDiscrepancy>>,
    TError,
    { discrepancyID: string; data: DiscrepancyPayload },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateDiscrepancy>>,
  TError,
  { discrepancyID: string; data: DiscrepancyPayload },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateDiscrepancy>>,
    { discrepancyID: string; data: DiscrepancyPayload }
  > = (props) => {
    const { discrepancyID, data } = props ?? {};

    return updateDiscrepancy(discrepancyID, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateDiscrepancyMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateDiscrepancy>>
>;
export type UpdateDiscrepancyMutationBody = DiscrepancyPayload;
export type UpdateDiscrepancyMutationError = ErrorType<
  | BboDeclarationBadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | BboDeclarationFailureResponseResponse
>;

/**
 * @summary Update Discrepancy
 */
export const useUpdateDiscrepancy = <
  TError = ErrorType<
    | BboDeclarationBadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | BboDeclarationFailureResponseResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateDiscrepancy>>,
    TError,
    { discrepancyID: string; data: DiscrepancyPayload },
    TContext
  >;
}) => {
  const mutationOptions = getUpdateDiscrepancyMutationOptions(options);

  return useMutation(mutationOptions);
};
